var _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSecurityAlert = function SvgSecurityAlert(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 140 140",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Security Alert")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5,61.3l5.6-26.2,25.1-2.3,46.2,45.5A56.9,56.9,0,0,0,130,70a60,60,0,1,0-60,60,60.8,60.8,0,0,0,16.1-2.2L70,111.9Z",
    fill: "#edf0f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.9,88.9a52.8,52.8,0,0,0,2.5-10.6L83.2,32.8,58.1,35.1,52.5,61.3,70,111.9l16.1,15.9h.4A60.1,60.1,0,0,0,126.9,88.9Z",
    fill: "#e6eaec"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6,57.4H83.4V48.7a13.4,13.4,0,0,0-26.8,0v8.7H49.4V48.7a20.6,20.6,0,1,1,41.2,0Z",
    fill: "#3c5a6b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49,56.8c-4.2,0-7.7,3.3-7.7,7.2V96.3c0,4,28.7,15.6,28.7,15.6V56.8Z",
    fill: "#ced6d9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7,96.3V64c0-3.9-3.5-7.2-7.7-7.2H70v55.1S98.7,100.3,98.7,96.3Z",
    fill: "#9cadb5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9,75.9a4.1,4.1,0,0,0-4.1-4.2,4.2,4.2,0,0,0-4.2,4.2,4.1,4.1,0,0,0,2.2,3.6l-2,10.8h7.9l-2-10.8A4.1,4.1,0,0,0,73.9,75.9Z",
    fill: "#3c5a6b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2,33.3l-.5-.2-9.5-8a.8.8,0,0,1-.1-1,.7.7,0,0,1,1,0L49.6,32a.7.7,0,0,1,.1,1A.5.5,0,0,1,49.2,33.3Z",
    fill: "#fbd149"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1,38.8h-.2L34,35.6a.7.7,0,0,1-.5-.9.7.7,0,0,1,.8-.5l12,3.3a.6.6,0,0,1,.5.8A.8.8,0,0,1,46.1,38.8Z",
    fill: "#fbd149"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1,29.3a.6.6,0,0,1-.6-.4L48.2,17.7a.8.8,0,0,1,.4-1,.7.7,0,0,1,.9.4l5.2,11.2a.7.7,0,0,1-.3,1Z",
    fill: "#fbd149"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecurityAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/security-alert.c4959575.svg";
export { ForwardRef as ReactComponent };